module.exports = __webpack_public_path__ + "static/img/plat.0902f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ranks/plat.png
// module id = rkNU
// module chunks = 1